

































	import Vue from 'vue';
    import _progress from '../../services/endpoints/progress';
    import _icons from '../../services/icons';

    export default Vue.extend({
        name: "InsightsComp",
        props: ['user', 'ownProfile'],
        data: () => ({
            insights: [] as any[]
        }),
        methods: {
            icon: function(name: any): string {
                return _icons.miscIcon(name);
            }
        },
        created: async function(): Promise<void> {
            if (this.ownProfile) this.insights = await _progress.insights(null);
            else this.insights = await _progress.insights(this.user.id);
        }
    })
